import { Component, Inject, DOCUMENT, ViewEncapsulation } from '@angular/core';
import { CoreConfig } from 'src/app/models/core-config.model';
import { constants } from 'src/app/shared';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AuthLayoutComponent {
  config?: CoreConfig;
  currentTheme?: string;
  loadingTheme: boolean = false;
  panelTitle?: string;

  constructor(
    authService: AuthService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.config = authService.getCoreConfig();
    this.panelTitle = this.config.panelTitle;

    setTimeout(() => {
      const theme = localStorage.getItem(constants.patronThemeKey) || 'light';
      this.loadTheme(theme);
    }, 50);
  }

  loadTheme(theme: string) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      this.loadingTheme = true;
      setTimeout(() => {
        themeLink.href = `${theme}.css`;
        localStorage.setItem(constants.patronThemeKey, theme);
      }, 250);
      setTimeout(() => {
        this.loadingTheme = false;
      });
    }
  }
}
